import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BasicTenderInfo from "../BriefTender/BasicTenderInfo";
import { useDownloadExcel } from "react-export-table-to-excel";
import ViewAllBidsExportExcel from "./ViewAllBidsExportExcel";

const ViewAllBids = () => {
  const { tenderId } = useParams();
  const [bidData, setBidData] = useState();
  const [groupedData, setGroupedData] = useState();
  const [tender, setTender] = useState();
  const [loading, setLoading] = useState(true);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [exportingExcel, setExportingExcel] = useState(false);

  const { onDownload } = useDownloadExcel({
    currentTableRef: groupedData && tableRef.current,
    filename: "Bids Comparison",
    sheet: "Bids Comparison",
  });

  const getBidData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/bid/get-all-by-tender?tenderId=${tenderId}&username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      const allBids = res.data.filter(Boolean);
      setBidData(res.data);
      setGroupedData(groupBidsByVendor(allBids));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const getTender = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTender(res.data);
    } catch (error) {
      console.error("Error updating tender status:", error);
    }
  };
  useEffect(() => {
    getTender();
    getBidData();
  }, []);

  const groupBidsByVendor = (bids) => {
    const grouped = {};
    bids.forEach((bid) => {
      const name = bid.vendor.name;
      if (!grouped[name]) {
        grouped[name] = [];
      }
      grouped[name].push(bid);
    });
    return grouped;
  };

  const groupedWorkItems =
    tender &&
    tender.workItemDetails.reduce((acc, item) => {
      if (!acc[item.section]) acc[item.section] = [];
      acc[item.section].push(item);
      return acc;
    }, {});

    useEffect(() => {
    const leftRows = document.querySelectorAll("#leftTable tbody tr");
    const rightRows = document.querySelectorAll("#rightTable tbody tr");

    for (let i = 0; i < Math.min(leftRows.length, rightRows.length); i++) {
      const leftHeight = leftRows[i].getBoundingClientRect().height;
      const rightHeight = rightRows[i].getBoundingClientRect().height;

      const maxHeight = Math.max(leftHeight, rightHeight);

      leftRows[i].style.height = `${maxHeight}px`;
      rightRows[i].style.height = `${maxHeight}px`;
    }
  }, [tender, groupedWorkItems, groupedData]);

  return (
    <div style={{position: 'relative'}}>
    {exportingExcel && (
        <div className="uploading-div" style={{ alignItems: "flex-start" }}>
          Exporting Excel... This may take a while.
        </div>
      )}
      <Typography variant="h6">Basic Information</Typography>
      <BasicTenderInfo tender={tender} />
      <Typography variant="h6">Bids Received</Typography>
      <Box className="dashboard-container" p={10}>
        <div style={{display: 'flex', justifyContent: 'end'}}>
          <Button
            className="btn-contained"
            sx={{ width: "auto" }}
            onClick={() => {
              if (!tableRef.current) {
                console.warn("Excel table not ready yet");
                return;
              }
              try {
                setExportingExcel(true);
                onDownload();
              } catch (error) {
                console.log(error);
              } finally {
                setExportingExcel(false);
              }
            }}
          >
            Export Comparatives Excel
          </Button>
        </div>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : tender && bidData && bidData.filter(Boolean).length > 0 ? (
          <div>

          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              id="leftTable"
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      padding: "9px",
                      width: "150px",
                      height: "97px",
                    }}
                    rowSpan={3}
                  >
                    Item Name
                  </th>
                  <th style={{ padding: "9px", width: "240px" }}>
                    Item Description
                  </th>
                  <th style={{ padding: "9px", width: "100px" }}>UOM</th>
                  <th style={{ padding: "9px", width: "100px" }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                      <tr
                        style={{
                          borderTop: "1px solid #ccc",
                          fontWeight: "bold",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "left",
                            padding: "0px 10px",
                            height: "41px",
                          }}
                        >
                          Section: {section}
                        </td>
                      </tr>
                      {items
                        .sort((a, b) => a.itemOrder - b.itemOrder)
                        .map((item, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                                // height: "50px",
                                padding: "10px"
                              }}
                            >
                              {item.itemName}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.description}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.unit}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.quantity}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      borderTop: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Grand Total (in &#8377;):
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={4}
                    style={{ borderTop: "1px solid #ccc", height: "40px" }}
                  >
                    Current Status
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
              id="rightTable"
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bidData && bidData?.length * 250}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {Object.entries(groupedData).map(([vendor, bids]) => (
                      <th
                        key={vendor}
                        colSpan={bids.length * 2}
                        style={{
                          padding: "9px",
                          borderBottom: "1px solid #ccc",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        {vendor}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {Object.entries(groupedData).flatMap(([vendor, bids]) =>
                      bids.map((_, i) => (
                        <React.Fragment key={`${vendor}-bid-${i}`}>
                          <th
                            style={{
                              padding: "8px",
                              borderBottom: "1px solid #ccc",
                              borderRight: "1px solid #ccc",
                            }}
                            colSpan={2}
                          >
                            Bid {i + 1}
                          </th>
                        </React.Fragment>
                      ))
                    )}
                  </tr>
                  <tr>
                    {Object.entries(groupedData).flatMap(([vendor, bids]) =>
                      bids.map((_, i) => (
                        <React.Fragment key={`${vendor}-headers-${i}`}>
                          <th
                            style={{
                              width: "100px",
                              borderTop: "1px solid #ccc",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            Rate (in &#8377;)
                          </th>
                          <th
                            style={{
                              width: "100px",
                              borderTop: "1px solid #ccc",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            Total (in &#8377;)
                          </th>
                        </React.Fragment>
                      ))
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        {/* Section Totals */}
                        <tr
                          style={{
                            borderTop: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          {Object.entries(groupedData).flatMap(
                            ([vendor, bids]) =>
                              bids.map((bid, i) => {
                                const sectionItems = bid.bidWorkItems.filter(
                                  (bi) =>
                                    items.find(
                                      (wi) => wi.itemName === bi.itemName
                                    )
                                );
                                const sectionTotal = sectionItems.reduce(
                                  (sum, si) => sum + ((si.quantity * si.rate) || 0),
                                  0
                                );
                                return (
                                  <React.Fragment
                                    key={`${vendor}-sectionTotal-${i}-${sectionIndex}`}
                                  >
                                    <td
                                      colSpan={2}
                                      style={{
                                        textAlign: "end",
                                        padding: "10px",
                                        height: "41px",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      {new Intl.NumberFormat("en-IN", {
                                          style: "decimal",
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }).format(sectionTotal)}
                                    </td>
                                  </React.Fragment>
                                );
                              })
                          )}
                        </tr>
                        {items.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.entries(groupedData).flatMap(
                              ([vendor, bids]) =>
                                bids.map((bid, i) => {
                                  const matchedItem = bid.bidWorkItems.find(
                                    (bi) =>
                                      bi.itemName === item.itemName &&
                                      bi.description === item.description &&
                                      bi.quantity === item.quantity &&
                                      bi.unit === item.unit
                                  );
                                  return (
                                    <React.Fragment
                                      key={`${vendor}-item-${i}-${rowIndex}`}
                                    >
                                      <td
                                        style={{
                                          borderTop: "1px solid #ccc",
                                          borderRight: "1px solid #ccc",
                                          // height: "50px"
                                          padding: "10px"
                                        }}
                                      >
                                        {matchedItem?.rate || ""}
                                      </td>
                                      <td
                                        style={{
                                          borderTop: "1px solid #ccc",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {(matchedItem?.quantity * matchedItem?.rate).toFixed(2) || ""}
                                      </td>
                                    </React.Fragment>
                                  );
                                })
                            )}
                          </tr>
                        ))}
                      </React.Fragment>
                    )
                  )}

                  {/* Grand Totals */}
                  <tr
                    style={{ fontWeight: "bold", borderTop: "1px solid #ccc" }}
                  >
                    {Object.entries(groupedData).flatMap(([vendor, bids]) =>
                      bids.map((bid, i) => {
                        const grandTotal = bid.bidWorkItems.reduce(
                          (acc, item) => acc + ((item.quantity * item.rate) || 0),
                          0
                        );
                        return (
                          <td
                            key={`${vendor}-grand-${i}`}
                            colSpan={2}
                            style={{
                              textAlign: "end",
                              padding: "10px",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            {new Intl.NumberFormat("en-IN", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(grandTotal)}
                          </td>
                        );
                      })
                    )}
                  </tr>

                  {/* Current Status Row - unchanged */}
                  <tr>
                    {Object.entries(groupedData).flatMap(([vendor, bids]) =>
                      bids.map((bid, i) => (
                        <td
                          key={`${vendor}-status-${i}`}
                          colSpan={2}
                          style={{
                            borderTop: "1px solid #ccc",
                            height: "40px",
                          }}
                        >
                          {storedUser.userRole[0] === "PURCHASE_HEAD" &&
                            (bid.bidStatus === "AWARDED" ||
                            bid.bidStatus === "SHORTLISTED"
                              ? "APPROVED"
                              : bid.bidStatus === "TECHNICALLY_QUALIFIED"
                              ? "REVIEW"
                              : bid.bidStatus === "REBID"
                              ? "REBID REQUESTED"
                              : bid.bidStatus)}
                          {bid.awardee1?.userRoleName ===
                            storedUser.userRole[0] &&
                            (bid.bidStatus === "AWARDED" ||
                            bid.bidStatus === "APPROVED"
                              ? "APPROVED"
                              : bid.bidStatus === "SHORTLISTED"
                              ? "REVIEW"
                              : bid.bidStatus === "REBID"
                              ? "REBID REQUESTED"
                              : bid.bidStatus)}
                          {bid.awardee2?.userRoleName ===
                            storedUser.userRole[0] &&
                            (bid.bidStatus === "AWARDED"
                              ? "APPROVED"
                              : bid.bidStatus === "APPROVED"
                              ? "REVIEW"
                              : bid.bidStatus === "REBID"
                              ? "REBID REQUESTED"
                              : bid.bidStatus)}
                        </td>
                      ))
                    )}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
            <Box ref={tableRef} sx={{display: 'none'}}>
              <ViewAllBidsExportExcel groupedWorkItems={groupedWorkItems} groupedData={groupedData} storedUser={storedUser} />
            </Box>
          </div>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor bid for the tender
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Box sx={{ display: "flex", gap: 5 }}>
          <Button
            className="btn-outlined"
            onClick={() => navigate(`/dashboard`)}
          >
            Back
          </Button>
          {storedUser.userRole[0] === "PURCHASE_HEAD" && (
            <Button
              className="btn-contained"
              onClick={() => navigate(`/dashboard/review-bid-data/${tenderId}`)}
              disabled={
                !bidData?.some(
                  (bid) => bid.bidStatus === "TECHNICALLY_QUALIFIED"
                ) || null
              }
            >
              Go To Shortlist
            </Button>
          )}
          {bidData?.some(
            (bid) =>
              bid?.awardee1 &&
              bid?.awardee1?.userRoleName === storedUser.userRole[0]
          ) && (
            <Button
              className="btn-contained"
              onClick={() => navigate(`/dashboard/review-bid-data/${tenderId}`)}
              disabled={
                !bidData?.some((bid) => bid.bidStatus === "SHORTLISTED") || null
              }
            >
              Go To Shortlist
            </Button>
          )}
          {bidData?.some(
            (bid) =>
              bid?.awardee2 &&
              bid.awardee2.userRoleName === storedUser.userRole[0]
          ) && (
            <Button
              className="btn-contained"
              onClick={() => navigate(`/dashboard/review-bid-data/${tenderId}`)}
              disabled={
                bidData?.some((bid) => bid.bidStatus === "AWARDED") || null
              }
            >
              Go To Shortlist
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default ViewAllBids;